import { Skeleton } from '@monksflow/monks-ui';

import type { CardGridSkeletonProps } from './CardGridSkeleton.types';

/**
 * Stands in for a grid of cards, matching the one-then-two-then-three column
 * rhythm that KnowledgeBaseList and the MCP marketplace both lay out.
 */
export const CardGridSkeleton = ({ count = 6, className }: CardGridSkeletonProps) => {
  return (
    <div
      role="status"
      aria-busy="true"
      className={`grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 ${className ?? ''}`}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} data-testid="card-grid-skeleton-card" className="h-45 rounded-3xl" />
      ))}
    </div>
  );
};

CardGridSkeleton.displayName = 'CardGridSkeleton';
